import { expValEquals } from '@confluence/feature-experiments';

export const isStickyInViewMode = (tableElement: HTMLElement | null): boolean => {
	return Boolean(tableElement?.getAttribute('mode') === 'stick');
};

export const isStickyInEditMode = (tableElement: HTMLElement | null): boolean => {
	if (
		expValEquals('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow')
	) {
		return Boolean(tableElement?.classList.contains('pm-table-row-native-sticky-active'));
	}
	return Boolean(tableElement?.classList.contains('pm-table-sticky'));
};

export const getIsSticky = (
	tableElement: HTMLElement | null,
	isEditor: boolean | undefined,
): boolean => (isEditor ? isStickyInEditMode(tableElement) : isStickyInViewMode(tableElement));
